export enum ReasonOfCarePathExclusion {
    concernsGgz = 'concernsGgz',
    concernsNsi = 'concernsNsi',
}
